<template>
  <div>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="10" class="request-details-container">
            <b-row>
              <span class="request-title">
                <a :href="getListingUrl(request)" target="_blank">{{request.shortDesc}}</a>
              </span>
            </b-row>
            <b-row class="single-line-row-fade">
              <span class>{{request.addressFormatted}}</span>
            </b-row>
          </b-col>
        </b-row>
        <div v-if="request.listingStatus=='active'">
          <md-list>
            <md-progress-bar v-if="loadingBlockedDates" md-mode="indeterminate"></md-progress-bar>
            <md-list-item v-else @click="toggleEditDates()">
              <md-icon>swap_horiz</md-icon>
              <span v-if="loadingBlockedDates">loading...</span>
              <span
                v-else-if="request.periodStart"
              >{{formatTime(request.periodStart)}} - {{formatTime(request.periodEnd)}}</span>
              <span v-else>{{i18n_local.info.specifyPeriod}}</span>
            </md-list-item>
            

            <!-- <md-list-item v-if="editRequest_time">
              <div>
                <md-datepicker
                  md-immediately
                  v-model="request.periodStart"
                  :md-disabled-dates="disabledMoveInDatesCalc"
                  class="hide-input-clear-x"
                >
                  <label>Move in</label>
                </md-datepicker>

                <md-datepicker
                  md-immediately
                  v-model="request.periodEnd"
                  :md-disabled-dates="disabledMoveOutDatesCalc"
                  class="hide-input-clear-x"
                >
                  <label>Move out</label>
                </md-datepicker>
              </div>
            </md-list-item> -->

            <md-list-item
              @click="!displayForProspect ? editRequest_price = !editRequest_price : null"
            >
              <md-icon>local_offer</md-icon>
              {{getRequestPricing}} € / {{getDisplayPriceTier(request)}}
            </md-list-item>

            <md-list-item v-if="editRequest_price && !displayForProspect">
              <md-field>
                <label>Custom Offer</label>
                <md-input v-model="request.customOffer" type="number"></md-input>
                <span class="md-suffix">€ / {{getDisplayPriceTier(request)}}</span>
              </md-field>
            </md-list-item>
          </md-list>

          <b-row v-if="request.aliveBookingId">
            <md-button
              v-if="displayForProspect"
              class="md-button md-primary play-cta-button makeup"
              @click="goToBooking(request.aliveBookingId)"
            >
              <span>Go To Booking</span>
            </md-button>
          </b-row>
          <b-row class="mt-3" v-else>
            <b-col lg="8" md="8" sm="6" cols="6">
              <moow-button
                v-if="editRequest_price || editRequest_time"
                :type="['light', 'wide']"
                :btnText="i18n_local.save"
                class="ml-3"
                :camel="true"
                :loading="loading"
                @mClick="saveRequestEdit(request)"
              />
              <moow-button
                v-if="displayForProspect && !editRequest_price && !editRequest_time"
                :type="['light', 'wide']"
                :camel="true"
                :btnText="i18n_local.ui.book"
                class="ml-3"
                :loading="loading"
                @mClick="bookNow(request)"
              />
            </b-col>
            <b-col  lg="4" md="4" sm="4" cols="4">
              <info-toggle 
                v-if="displayForProspect && !editRequest_price && !editRequest_time"
                :infoContent="i18n_local.info.booking" size="small" />
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <p>
            <i>The property is not available anymore</i>
          </p>
        </div>
      </b-col>
    </b-row>


    <md-dialog
      width="400"
      :md-close-on-esc="true"
      :md-click-outside-to-close="true"
      :md-active.sync="editRequest_time"
      class="scrolly-dialog"
      md-fullscreen
    >
      <md-dialog-title class="moow-header-2">{{
        i18n_local.edit_stay_period
      }}</md-dialog-title>
      <md-content style="padding: 1em">
        <date-picker
          :disabledDates="isDateBlocked"
          @emitDatesSelected="datesSelected"
          actionButtonTitle="Cancel"
          @emitActionButton="closeDatePicker"
          :minDateRangeInDays="minStayPeriodInDays"
          :minRangeMessage="getMinRangeMessage(minStayPeriodInDays)"
        />
      </md-content>
    </md-dialog>

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}!</span>
      <md-button class="md-accent" @click="snackbarCTA()">{{snackbarCTATxt}}</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import {
  formatTimeToMonDD,
  calculateDiffOfDays,
  formatTimeToDDMMYYFromString
} from "../../timeFunctions.js";
import {
  calcRentPricingDetails,
  calcRentPricingDetailsCustom,
  calcPricingTier
} from "../../pricing/pricingCalculator.js";
import { mapState, mapGetters } from "vuex";
import { upsertRequest } from "../../requestRepository.js";
import { mapActions } from "vuex";
import PropertyCalendarService from "@/services/property-calendar";
import PropertyCalendarInputTransformer from "@/transformers/input/property-calendar";
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";
import dayjs from "dayjs";

export default {
  props: {
    request: {
      type: Object,
      required: true
    },
    pricingRules: {
      type: Object,
      required: true
    },
    displayForProspect: {
      type: Boolean,
      required: true
    },
    loadingRedirectToggle: {
      type: Function,
      required: false
    }
  },
  components: {
    ContentLoader, InfoToggle
  },
  data() {
    return {
      loadingBlockedDates: true,
      entries: [],
      snackbarCTATxt: "",
      snackbarMessage: "",
      snackbarCode: undefined,
      showSnackbar: false,
      txnDet: undefined,
      loading: false,
      disabledBookingDates: [],
      loadingDisabledBookingDates: true,
      currentlyInProcessRequestId: -1,
      editRequest_time: false,
      editRequest_price: false,
      showDatePeriodDialog: false
    };
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    // ...mapState("propertyCalendarModule", ["entries"]),
    minStayPeriodInDays(){
      if (this.request.txnDet.priceDaily) return undefined
      else return 31  // no daily pricing, min stay is 31 days
    },
    requestStartPeriodComputed() {
      return this.request.periodStart;
    },
    requestEndPeriodComputed() {
      return this.request.periodEnd;
    },
    disableBookingRequest() {
      if (!this.bookingRequestPeriodEnd || !this.bookingRequestPeriodStart)
        return true;
      else return false;
    },
    getRequestPricing() {
      var rentPriceDetails;
      if (this.request.customOffer) {
        rentPriceDetails = calcRentPricingDetailsCustom(
          this.request.customOffer,
          this.request.periodStart,
          this.request.periodEnd
        );
      } else {
        rentPriceDetails = calcRentPricingDetails(
          this.getBaseRents(this.request.txnDet),
          this.request.periodStart,
          this.request.periodEnd,
          this.getDiscounts(this.request.txnDet),
          this.pricingRules
        );
      }

      if (this.request.customOffer) return this.request.customOffer;
      else if (rentPriceDetails.priceTier == "month")
        return rentPriceDetails.rentMonthly;
      else return rentPriceDetails.rentDaily;
    }
  },
  watch: {
    requestStartPeriodComputed: function(val, oldVal){
      if(val && oldVal){
        val.setHours(0,0,0,0)
        oldVal.setHours(0,0,0,0)
        if(val.getTime() != oldVal.getTime()){
          console.log("start date has changed from ", oldVal, " to : ", val)
          this.request.periodEnd = null
        }
      } 
    }
  },
  created() {
    this.retireveBlockedDates();
    // this.getEntries({
    //   propertyId: this.request.propertyId
    // });
  },
  methods: {
    ...mapActions("propertyCalendarModule", [
      "checkAvailability",
      "getEntries"
    ]),
    getMinRangeMessage(minStayPeriodInDays){
      if(!minStayPeriodInDays) return ""
      return this.i18n_local.min_stay_period_is + " " +minStayPeriodInDays + " " + this.i18n_local.days
    },
    datesSelected({ startDate, endDate }) {
      this.request.periodStart = startDate;
      this.request.periodEnd = endDate;
      this.editRequest_time = false;
    },
    closeDatePicker(){
      this.editRequest_time = false;
    },
    toggleEditDates(){
      if(!this.loadingBlockedDates) this.editRequest_time = !this.editRequest_time
    },
    async retireveBlockedDates() {
      try {
        // TODO: move this to store (create new separate module from the existing one)
        this.loadingBlockedDates = true;
        const response = await PropertyCalendarService.getEntries({
          propertyId: this.request.propertyId
        });
        const transformed = PropertyCalendarInputTransformer.transform(
          response.data
        );
        this.entries = transformed;
      } catch (error) {
        throw error;
      } finally {
        this.loadingBlockedDates = false;
      }
    },
    snackbarCTA() {
      if (this.snackbarCode == 1){
        this.$emit("emitRedirectTo", { where: "account", openTab: "tab-identity" });
      }
    },
    imageOrPlaceholder(imageUrl) {
      if (imageUrl) return imageUrl;
      else return require("../../assets/placeholder.png");
    },
    goToBooking(bookingId) {
      this.$router.push({
        name: "deal",
        params: {
          dealId: bookingId
        }
      });
    },
    requiredBookingVariablesSet(request) {
      var result = true;
      if (!request.periodStart || !request.periodEnd) result = false;
      else if (request.periodStart >= request.periodEnd) result = false;

      if (!result) {
        this.notifyUser("Missing correct dates", "check move in and out dates");
        return false;
      }
      if (request.customOffer < 0) {
        this.notifyUser("Custom offer cannot be negative", "fix pricing");
        return false;
      }
      if (!this.getRequestPricing) {
        this.notifyUser("Missing price", "Landlord will fix pricing");
        return false;
      }
      return true;
    },
    setRequestPricing(request) {
      var rentPriceDetails;
      if (request.customOffer) {
        rentPriceDetails = calcRentPricingDetailsCustom(
          request.customOffer,
          request.periodStart,
          request.periodEnd
        );
      } else {
        rentPriceDetails = calcRentPricingDetails(
          this.getBaseRents(request.txnDet),
          request.periodStart,
          request.periodEnd,
          this.getDiscounts(request.txnDet),
          this.pricingRules
        );
      }
      request.agreedDeal = rentPriceDetails;
      if (request.customOffer) return request.customOffer;
      else if (request.agreedDeal.priceTier == "month")
        return request.agreedDeal.rentMonthly;
      else return request.agreedDeal.rentDaily;
    },
    getDisplayPriceTier(request) {
      return calcPricingTier(request.periodStart, request.periodEnd);
    },
    getBaseRents(txnDet) {
      return {
        rentDaily: txnDet.priceDaily,
        rentMonthly: txnDet.priceMonthly
      };
    },
    getDiscounts(txnDet) {
      return {
        weeklyDiscount: txnDet.weeklyDiscount,
        mediumPeriodDiscount: txnDet.mediumPeriodDiscount,
        longPeriodDiscount: txnDet.longPeriodDiscount
      };
    },
    getListingUrl(request) {
      return "/#/listing/" + request.listingMaaklerId;
    },
    removeTimezone(request) {
      request.periodStart = new Date(
        Date.UTC(
          request.periodStart.getFullYear(),
          request.periodStart.getMonth(),
          request.periodStart.getDate()
        )
      ).toISOString();
      request.periodEnd = new Date(
        Date.UTC(
          request.periodEnd.getFullYear(),
          request.periodEnd.getMonth(),
          request.periodEnd.getDate()
        )
      ).toISOString();
    },
    findNextBlockedDate(fromThis){
      for (const entry of this.entries) {
        const startOfBlock = new Date(entry.startDate);
        const diffTime = startOfBlock - fromThis 
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if(diffDays > 0) return startOfBlock
      }
      return false
    },
    // TODO: move to mix-in
    isDateBlocked(dateInQuestion) {
      const today = new Date();
      if (dateInQuestion < today) return true;

      if (!Array.isArray(this.entries) || !this.entries.length) {
        return false;
      }

      for (const entry of this.entries) {
        const startDate = dayjs(new Date(entry.startDate));
        const endDate = dayjs(new Date(entry.endDate));
        if (
          (dateInQuestion.isSame(startDate) ||
            dateInQuestion.isAfter(startDate)) &&
          (dateInQuestion.isSame(endDate) ||
            dateInQuestion.isBefore(endDate) ||
            entry.termless)
        ) {
          return true;
        }
      }

      return false;
    },
    // disabledMoveInDatesCalc(dateInQuestion) {
    //   if (this.isDateBlocked(dateInQuestion)) {
    //     return true;
    //   }
    //   const today = new Date();

    //   return dateInQuestion <= today;
    // },
    // disabledMoveOutDatesCalc(dateInQuestion) {
    //   if (this.isDateBlocked(dateInQuestion, this.request.periodStart)) {
    //     return true;
    //   }

    //   var minMoveOutDate;
    //   if (this.request.periodStart) {
    //     // disable all dates older than moveInDate
    //     if (!this.request.txnDet.priceDaily) {
    //       //if no daily price set limit minimum stay to 30 days
    //       minMoveOutDate = new Date(this.request.periodStart);
    //       minMoveOutDate.setDate(minMoveOutDate.getDate() + 31);
    //     } else {
    //       // else limit to 1 day
    //       minMoveOutDate = new Date(this.request.periodStart);
    //       minMoveOutDate.setDate(minMoveOutDate.getDate() + 1);
    //     }
    //   } else {
    //     // if move in is not specified limit to future
    //     minMoveOutDate = new Date();
    //   }
    //   return dateInQuestion < minMoveOutDate;
    // },
    getListingUrl(request) {
      return "/#/listing/" + request.listingMaaklerId;
    },
    formatTime(time) {
      return formatTimeToDDMMYYFromString(time);
    },
    // TODO: instead, create a mix-in and plug it in
    async checkPropertyAvailability(request) {
      return await this.checkAvailability({
        propertyId: this.request.propertyId,
        startDate: new Date(request.periodStart).toISOString(),
        endDate: new Date(request.periodEnd).toISOString(),
        termless: false
      });
    },
    async saveRequestEdit(request) {
      try {
        this.loading = true;
        if (!this.requiredBookingVariablesSet(request)) {
          this.loading = false;
          return;
        }
        this.setRequestPricing(request);
        this.removeTimezone(request);
        if (!(await this.checkPropertyAvailability(request))) {
          console.log("Selected dates are not available for chosen property");

          this.notifyUser(
            "Selected dates are not available for chosen property"
          );
          this.loading = false;

          return;
        }
        this.editRequest_time = false;
        this.editRequest_price = false;
        this.loading = false;

        var whatChanged;
        // Prospect can only change period. TODO: Change to more accomodating logic
        if (this.displayForProspect) whatChanged = "period";
        else whatChanged = "price";

        this.$emit("emitSaveRequestEdits", { request, whatChanged });

        upsertRequest(request).catch(err => {
          this.notifyUser("Cannot update request");
        });
      } catch (error) {
        this.notifyUser(
          "An error occurred while checking the property availability for selected dates"
        );
      }
    },
    removeTimezone(request) {
      var startDate = new Date(request.periodStart);
      var endDate = new Date(request.periodEnd);
      request.periodStart = new Date(
        Date.UTC(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate()
        )
      ).toISOString();
      request.periodEnd = new Date(
        Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
      ).toISOString();
    },
    notifyActionMessage(message, ctaTxt, code) {
      (this.showSnackbar = true), (this.snackbarMessage = message);
      this.snackbarCTATxt = ctaTxt;
      this.snackbarCode = code;
    },
    async bookNow(request) {
      try {
        if (!this.requiredBookingVariablesSet(request)) {
          return;
        }
        this.setRequestPricing(request);
        this.loading = true;

        if (!(await this.checkPropertyAvailability(request))) {
          console.log("Selected dates are not available for chosen property");
          this.notifyUser(
            "Selected dates are not available for chosen property"
          );
          this.loading = false;
          return;
        }

        if (!this.$store.getters.privatePerson._id) {
          this.$emit("emitRedirectTo", { where: "account", openTab: "tab-identity", bookingRequest: request});
          return
        }
        this.loading = false;
        this.loadingRedirectToggle(true);

        this.$emit("emitStartBookingApplication", { bookingRequest: request});
        // upsertRequest(request).then(resp => {
        //   if (resp) {
        //     this.navigationProxy({
        //       where: "bookingApplication",
        //       params: { bookingRequest: request }
        //     });
        //     this.loadingRedirectToggle(false);
        //   } else {
        //     this.loadingRedirectToggle(false);
        //   }
        // });
      } catch (error) {
        this.notifyUser(
          "An error occured while checking the property availability for selected dates"
        );
      }
    },
    formatTime(time) {
      return formatTimeToDDMMYYFromString(time);
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    navigationProxy({ where, params }) {
      //this.$emit("emitRedirectTo", { where, params });
      this.navigateTo({ where, params });
    },
    navigateTo({ where, params }) {
      this.$router.push({
        name: where,
        params: params
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";

.request-title {
  font-size: 18px;
}

.request-period-view-only {
  font-size: 20px;
  text-align: center;
  line-height: 48px;
  padding-left: 15px;
}

.booking-request-content-container {
  padding: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/listingRequest.vue